import { Table } from "@tanstack/react-table"
import { Table as TableWrapper } from "./Table"
import { TBody } from "./TBody"
import { TFoot } from "./TFoot"
import { THead } from "./THead"

interface Props<T> {
    defaultPageSize?: number
    table: Table<T>
}

export function GenericTable<T>({ defaultPageSize = 12, table }: Props<T>) {
    return (
        <TableWrapper>
            <THead headerGroups={table.getHeaderGroups()} />
            <TBody rowModel={table.getRowModel()} />
            <TFoot defaultPageSize={defaultPageSize} table={table} />
        </TableWrapper>
    )
}
